var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7775 3.81289C21.9389 3.81289 7.47779 12.8511 7.47779 24.0002C7.47779 35.1493 21.9389 44.1875 39.7775 44.1875C57.6161 44.1875 72.0771 35.1493 72.0771 24.0002C72.0771 12.8511 57.6161 3.8129 39.7775 3.81289Z",
    fill: "#FFDFD6",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7775 15.1797C21.9389 15.1797 7.47779 19.1286 7.47779 23.9998C7.47779 28.8709 21.9389 32.8198 39.7775 32.8198C57.6161 32.8198 72.0771 28.8709 72.0771 23.9998C72.0771 19.1286 57.6161 15.1797 39.7775 15.1797Z",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7773 3.8129C32.3692 3.81289 26.3637 12.8511 26.3637 24.0002C26.3637 35.1493 32.3692 44.1875 39.7773 44.1875C47.1854 44.1875 53.1909 35.1493 53.1909 24.0002C53.1909 12.8511 47.1854 3.8129 39.7773 3.8129Z",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.3d31fd8065a93e42659dcb1236771271.svg";
export { ForwardRef as ReactComponent };